import MembershipsStep from './MembershipsStep';
import { withPopup } from './Utils';

export default withPopup(MembershipsStep, { disableShiftCrossAxis: true });
